export default {
  btnPrime: 'od-primaryBtn-active-bgFill od-primaryBtn-active-stroke od-primaryBtn-active-btnTxt',
  btnSecondary: 'od-secondaryBtn-active-bgFill od-secondaryBtn-active-stroke od-secondaryBtn-active-btnText',
  btnTertiary: 'od-tertiaryBtn-active-bgFill od-tertiaryBtn-active-stroke od-tertiaryBtn-active-btnText',
  btnPrimeDisabled: 'od-primaryBtn-disabled-bgFill od-primaryBtn-disabled-stroke od-primaryBtn-disabled-btnTxt',
  btnDisabled: 'od-primaryBtn-disabled-bgFill od-primaryBtn-disabled-stroke od-primaryBtn-disabled-btnTxt',
  disabledTextfield: 'od-form-common-BackgroundFill-disabled od-form-common-stroke-disabled',
  activeTextfield: 'od-form-common-BackgroundFill-active od-form-common-stroke-active od-form-common-text-displayText',
  defaultTextField: { label: 'od-form-common-text-label', field: 'od-form-common-BackgroundFill-default od-form-common-stroke-default od-form-common-text-displayText' }
};
